// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"89a4557f","952":"39834a75"}[chunkId] + ".chunk.js";
};